import apiClient from "../utils/apiClient";

const categoryApi = (kind) => {
  const base = kind === "legal" ? "/api/tai-lieu-phap-luat/doc-types" : "/api/tai-lieu-van-hoa/sub-categories";

  return {
    list: () => apiClient.get(base),
    create: (data) => apiClient.post(base, data),
    update: (id, data) => apiClient.put(`${base}/${id}`, data),
    remove: (id) => apiClient.delete(`${base}/${id}`),
  };
};

export const legalDocumentCategoriesApi = categoryApi("legal");
export const historyDocumentCategoriesApi = categoryApi("history");
